import { render, staticRenderFns } from "./b3.vue?vue&type=template&id=5228a112&scoped=true&"
import script from "./b3.vue?vue&type=script&lang=js&"
export * from "./b3.vue?vue&type=script&lang=js&"
import style0 from "./b3.vue?vue&type=style&index=0&id=5228a112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228a112",
  null
  
)

export default component.exports